import { Box } from '@mantine/core';

const Footer = () => {
  return (
    <Box className="footer-links" fz="sm">
      <a
        target="_blank"
        rel="noreferrer"
        href="https://releva.ai/terms-of-use?utm_source=releva-website&utm_medium=website&utm_campaign=website-navigation&utm_content=pageView-Footer"
      >
        Terms of Use
      </a>
      {' | '}
      <a
        target="_blank"
        rel="noreferrer"
        href="https://releva.ai/privacy-policy?utm_source=releva-website&utm_medium=website&utm_campaign=website-navigation&utm_content=pageView-Footer"
      >
        Privacy Policy
      </a>
    </Box>
  );
};

export default Footer;
